import shortid from 'shortid';

export function prettySize(bytes) {
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];

  let lBytes = Math.max(bytes, 0);
  let pow = Math.floor((lBytes ? Math.log(lBytes) : 0) / Math.log(1024));
  pow = Math.min(pow, units.length - 1);

  // Uncomment one of the following alternatives
  // $bytes /= pow(1024, $pow);
  lBytes /= 1 << (10 * pow);
  return `${Math.round(lBytes)} ${units[pow]}`;
}
export function uniqueKey() {
  const id = shortid.generate();
  if (shortid.isValid(id)) {
    return id;
  }
}

export function formatSize(bytes, precision = 2) {
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) return '0 Byte';
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1000)));
  const size = bytes / Math.pow(1000, i);
  return size.toFixed(precision) + ' ' + sizes[i];
}

const removeScrollClass = 'remove-scroll';
export function removeScroll(
  addScroll = false,
  el = document.querySelector('body')
) {
  if (el) {
    if (addScroll) {
      el.classList.add(removeScrollClass);
    } else {
      el.classList.remove(removeScrollClass);
    }
  }
}
